<template>
  <div class="page-recherche">
    <main class="main">
      <breadcrumbs></breadcrumbs>

      <div class="page_title">
        <h2>Recherche générale</h2>
      </div>

      <div class="main-content">
        <div class="col-100 recherche-barre">
          <h2>Terme(s) de recherche(s):</h2>
          <input
            v-model="searchInput.terms"
            v-on:keypress.enter="search()"
            type="search"
            id="recherche"
          />
          <input @click="search() " type="submit" value="Rechercher">
        </div>

        <div @change="updateDocType()" class="col-15 filtre-side recherche-filtre-side">
          <h2>Type de contenu</h2>
          <div class="filtre-side-items">
            <div class="filtre-side-item">
              <input
                v-model="docType.new"
                type="checkbox"
                id="sub1"
              />
              <label for="sub1">Actualités</label>
            </div>
            <div class="filtre-side-item">
              <input
                v-model="docType.product"
                type="checkbox"
                id="sub2"
              />
              <label for="sub2">Produits</label>
            </div>
            <div class="filtre-side-item">
              <input
                v-model="docType.activesubstance"
                type="checkbox"
                id="sub3"
              />
              <label for="sub3">Substances actives & macro-organismes</label>
            </div>
            <div class="filtre-side-item">
              <input
                v-model="docType.flatpage"
                type="checkbox"
                id="sub4"
              />
              <label for="sub4">Articles</label>
            </div>
          </div>
        </div>

        <general-listing
          :page.sync="queryParams.page"
          :itemList="results"
          @changePage="updateUrl()"
        ></general-listing>
      </div>
    </main>
  </div>
</template>

<script>
import SearchMixin from '@/mixins/SearchMixin.js'
import Breadcrumbs from '@/components/Breadcrumbs'
import GeneralListing from '@/components/GeneralListing'
import GeneralSearch from '@/api/generalSearch.js'

export default {
  name: 'GeneralSearch',
  components: { Breadcrumbs, GeneralListing },
  mixins: [SearchMixin],

  data () {
    return {
      queryParams: {
        page: 1,
        exclude: null
      },
      searchInput: {
        terms: ''
      },
      docType: {
        product: true,
        activesubstance: true,
        new: true,
        flatpage: true
      },
      results: {}
    }
  },

  created () {
    this.queryParams = { ...this.$route.query }
    this.putQueryParamsInSearchInput()
    this.putQueryParamsInDocType()
    this.handleMultiValuatedQueryParam(['exclude'])
    this.getResults()
  },

  beforeRouteUpdate (to, from, next) {
    this.queryParams = { ...to.query }
    this.putQueryParamsInSearchInput()
    this.putQueryParamsInDocType()
    this.handleMultiValuatedQueryParam(['exclude'])
    this.getResults()
    next()
  },

  methods: {
    getResults () {
      this.queryParams.page = Number(this.queryParams.page) || 1
      GeneralSearch.search(this.queryParams)
        .then(response => { this.results = response.results 
        })
    },

    search () {
      this.queryParams.page = undefined
      this.putSearchInputInQueryParams()
      this.updateUrl()
      
    },

    updateDocType () {
      this.queryParams.page = undefined
      this.putDocTypeInQueryParams()
      this.updateUrl()
    },
    
    putDocTypeInQueryParams () {
      let excludeList = []
      for (const prop in this.docType) {
        if (!this.docType[prop]) excludeList.push(prop)
      }

      this.queryParams.exclude = excludeList
    },

    putQueryParamsInDocType () {
      for (const prop in this.docType) {
        if (this.queryParams.hasOwnProperty('exclude') && this.queryParams.exclude.indexOf(prop) !== -1) {
          this.docType[prop] = false
        } else {
          this.docType[prop] = true
        }
      }
    }
  }
}
</script>
